 export default {
 products_search: "ابحث عن المنتجات...",
      stock: "المخزون",
      in_stock: "متوفر",
      low_stock: "مخزون منخفض",
      out_of_stock: "غير متوفر",
      expiry: "تاريخ الانتهاء",
      valid: "صالح",
      expired: "منتهي",
      offer: "عرض",
      country: "الدولة",
      reset: "إعادة ضبط",
      view_inactive: "عرض المنتجات غير النشطة",
      hide_inactive: "إخفاء المنتجات غير النشطة",
      restore: "استرجاع",

      deactivate_product: "إلغاء تفعيل المنتج",
      confirm_deactivate: "هل أنت متأكد من إلغاء التفعيل؟",
      cancel: "إلغاء",
      yes_deactivate: "نعم، إلغاء",

      price: "السعر",
      Supcurrency: "العملة",
      units: "الوحدات",
      uom: "وحدة القياس",
      moq: "الحد الأدنى للطلب",
      offer_valid: "صلاحية العرض",
      offer_time: "وقت العرض",
      offer_starts: "بداية العرض",
      currency_code: "ريال",
      ends_in: "ينتهي خلال {{count}} دقيقة",
starts_in: "يبدأ خلال {{count}} دقيقة",
starts_tomorrow: "يبدأ غداً",
starts_days: "يبدأ خلال {{count}} أيام",
upcoming: "قريباً",
percent_off: "خصم {{value}}%",
flat_off: "خصم {{value}}",
buy_get: "اشترِ {{buy}} واحصل على {{get}}",
offer: "عرض",
percentage: "نسبة مئوية",
flat: "خصم ثابت",
bogo: "اشترِ 1 واحصل على 1",
no_offer: "بدون عرض",
product_actions: "إجراءات المنتج",
stock_quantity: "كمية المخزون",
price_per_unit: "السعر لكل وحدة",
expiry_date: "تاريخ الانتهاء",
expiry_time: "وقت الانتهاء",
minimum_order_quantity: "الحد الأدنى للطلب",
unit_of_measure: "وحدة القياس",
existing_images: "الصور الحالية",
choose_images: "اختر الصور",
back: "رجوع",
save: "حفظ",
edit_inventory: "تعديل المخزون",
manage_offer: "إدارة العرض",
close: "إغلاق",
deactivate_product: "إلغاء تفعيل المنتج",
confirm_deactivate: "هل أنت متأكد من إلغاء التفعيل؟",
cancel: "إلغاء",
yes_deactivate: "نعم، إلغاء التفعيل",
edit_offer: "تعديل العرض",
create_offer: "إنشاء عرض",
offer_title: "عنوان العرض",
description: "الوصف",
offer_type: "نوع العرض",
select_offer_type: "اختر نوع العرض",
discount_percentage: "نسبة الخصم (%)",
flat_discount: "قيمة الخصم الثابت",
buy_quantity: "كمية الشراء",
get_quantity: "كمية الحصول",
start_date: "تاريخ البداية",
end_date: "تاريخ النهاية",
start_time: "وقت البداية",
end_time: "وقت النهاية",
status: "الحالة",
toggle_offer: "تفعيل / إلغاء تفعيل العرض",
update_offer: "تحديث العرض",
add_product: "إضافة منتج جديد",
manage_product_info: "إدارة معلومات المنتج",
bulk_upload: "تحميل جماعي",

business_details: "تفاصيل العمل",
company_name: "اسم الشركة",
supbranch: "الفرع",
select_branch: "اختر الفرع",
supstore: "المتجر",
select_store: "اختر المتجر",

product_details: "تفاصيل المنتج",
product_name_en: "اسم المنتج (إنجليزي)",
product_name_ar: "اسم المنتج (عربي)",
category: "الفئة",
select_category: "اختر الفئة",
sub_category: "الفئة الفرعية",
select_subcategory: "اختر الفئة الفرعية",
select_unit: "اختر الوحدة",

pricing_availability: "التسعير والتوفر",
stock_available: "المخزون المتوفر",
shelf_life: "مدة الصلاحية (أيام)",

product_images: "صور المنتج",
drag_drop_images: "اسحب الصور هنا",
click_upload: "أو اضغط للتحميل",

save_product: "حفظ المنتج",

product_name_required: "اسم المنتج مطلوب",
supplier_not_logged: "المورد غير مسجل",
product_added_success: "تم إضافة المنتج بنجاح",
product_failed: "فشل في حفظ المنتج",
  "product_name_english": "اسم المنتج بالإنجليزية",
  "product_name_arabic": "اسم المنتج بالعربية",
  delivery_time_minutes: "زمن التسليم"
 }